export const randomDuration = () => Math.random() * 0.07 + 0.23;
